export const defaultEntity = "resi";
export const entities = ["resi", "reso"];
export const labels = {
  resi: "Resi",
  reso: "Reso",
};
